'use client';

import Image from 'next/image';
import React from 'react';

import { IResolvedBanner } from '@/src/utils/collections/banner.mapper';
import { BannerImage } from '@/src/components/banner/BannerImage/BannerImage';
import { BannerColor } from '@/src/components/banner/BannerColor/BannerColor';
import { IResolvedFaqCategory } from '@/src/utils/collections/faq/faq-categories.mappers';
import { IZoneWithDestinationsAndPromo } from '@/src/modules/destinations/destinations.modules';

interface IProps extends IResolvedBanner {
  destinations?: Record<string, IZoneWithDestinationsAndPromo>;
  faqCategories?: IResolvedFaqCategory[] | null;
  popularDestinations?: Record<string, IZoneWithDestinationsAndPromo>;
}

export function Banner(props: IProps) {
  return (
    <>
      {props.background.type === 'image' && <BannerImage {...props} />}
      {props.background.type === 'color' && (
        <div className="relative w-full">
          {props.background.color !== 'bg-black' && (
            <Image
              src={'/static/icons/title-decoration-yellow.svg'}
              alt="background-shape"
              width={450}
              height={300}
              className="decoration-visible absolute right-0 top-0 -z-10 hidden w-[300px] -scale-x-100 opacity-25 lg:w-[450px] xl:top-[-50px] xl:w-[600px] 2xl:w-[700px]"
            />
          )}
          <BannerColor {...props} />
        </div>
      )}
    </>
  );
}
